var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('single-product')],1)],1),_c('footer',[_c('page-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }